import { render, staticRenderFns } from "./AnswerSelectOption.vue?vue&type=template&id=4563ac7d&"
import script from "./AnswerSelectOption.vue?vue&type=script&lang=js&"
export * from "./AnswerSelectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports